module.exports = __webpack_public_path__ + "assets/img/lithuania-grey.acdfcf05.png";